import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BuyFunctionality } from '../../spotlight/models/purchase/buy-functionality.class';
import { CookiesService } from 'src/app/core/services/Cookie/cookies.service';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { ErrorMessage } from '../../spotlight/models/purchase/error-message.model';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PromoCodePopupComponent } from '../promo-code-popup/promo-code-popup.component';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { E } from '@angular/cdk/keycodes';
@Component({
  selector: 'app-buy-functionality',
  templateUrl: './buy-functionality.component.html',
  styleUrls: ['./buy-functionality.component.css']
})
export class BuyFunctionalityComponent implements OnInit {

  @Input() eventId: number;
  @Output() changeError = new EventEmitter<ErrorMessage>();
  @Output() enableCart = new EventEmitter();
  @Input() premiere: any;
  @Input() allAccessPassStage: any;
  errorMessage = new ErrorMessage();
  buyModel: BuyFunctionality;
  isAlreadyInCart: boolean;
  isInvalidPromoCode: boolean;
  isFromPromoCodePopup: boolean;
  isLoading: boolean;
  eventTierId: string;
  showingId: string;
  selectedEventId: number;
  promoCode: string;
  fullLineup: any;
  allAccessEventId: any;
  allAccessShowingId: any;
  allAccessEventTierId: any;

  enableBuyTksNew(promoCodeObject: any): void {
    this.promoCode = promoCodeObject.promoCode;
    this.enableBuyTks(promoCodeObject.isFromPromoCodePopup);
  }
  openPromoCodePopup(): void {
    const modalRef = this.modalService.open(PromoCodePopupComponent, { size: 'sm', backdrop: 'static', windowClass: 'dark-modal' });
    modalRef.componentInstance.promoCode = this.promoCode;
    modalRef.componentInstance.enableBuyTksNew.subscribe(($e) => {
      this.enableBuyTksNew($e);
    });
  }

  enableBuyTks(isFromPromoCodePopup: boolean): void {
    this.isFromPromoCodePopup = isFromPromoCodePopup;
    this.isInvalidPromoCode = false;
    this.eventTierId = '';
    this.allAccessEventId = '';
    this.showingId = '';
    this.allAccessShowingId ='';
    this.isAlreadyInCart = false;
    this.buyModel = new BuyFunctionality();
    this.isLoading = true;
    try {
      if (this.buyModel.priceToPick.TicketType === 'Streaming' && this.promoCode !== undefined && this.promoCode !== '') {
          this.isInvalidPromoCode = true;
          this.promoCode = '';
      }
    } catch (e){}
    this.cookiesService.setCookieValue('promoCode', this.promoCode);
    if(this.allAccessPassStage){
      this.agileIntegrationService.getAllAccessListPrices(this.promoCode).subscribe((response: any) => {
        console.log("all access pass", response)
        this.isAlreadyInCart = response.isAlreadyInCart;
        this.buyModel.eventListPricesName = response.Name;
  
        for (let i = 0; i < response.Prices.length; i++) {
          const Prices = response.Prices;
          if (i === 0) {
            this.buyModel.basePrice = Prices[i].BasePrice;
            this.eventTierId = Prices[i].TierID;
            this.buyModel.priceToPick = Prices[i];
          } else {
            if (Prices[i].BasePrice < this.buyModel.basePrice) {
              this.buyModel.basePrice = Prices[i].BasePrice;
              this.eventTierId = Prices[i].TierID;
              this.buyModel.priceToPick = Prices[i];
  
            }
          }
        }       
        this.eventId = response.EventID;
        this.showingId = response.showingId;
        console.log("event id", this.eventId);
        console.log("showing id", this.showingId);
        if (this.buyModel.priceToPick.TicketType === 'All Access Pass' && this.promoCode !== undefined && this.promoCode !== '') {
          this.isInvalidPromoCode = true;
          this.promoCode = '';
          this.cookiesService.setCookieValue('promoCode', this.promoCode);
        }
        this.isLoading = false;
      },
      (error: any) => {
        console.log(error);
        if(error === 500){
        this.errorMessage.errorMessage = 'Requested Item is currently not on sale.';
        this.errorMessage.isError = true;
        this.changeError.emit(this.errorMessage);
        this.isLoading = false;
        }
        else if(error === 403){
          this.errorMessage.errorMessage = 'Login to Creatics to purchase tickets.';
          this.errorMessage.isError = true;
          this.changeError.emit(this.errorMessage);
          this.isLoading = false;
        }
        else{
        this.errorMessage.errorMessage = 'Something went wrong.';
        this.errorMessage.isError = true;
        this.changeError.emit(this.errorMessage);
        this.isLoading = false;
        }
      });
    }else{
      this.agileIntegrationService.getEventListPrices(this.eventId, this.promoCode).subscribe((response: any) => {
        console.log(response,'HIIIIIIII')
        const singleLineup = this.premiere;
        this.buyModel.ShortDescriptive1 = singleLineup.ShortDescriptive1;
        this.buyModel.type = singleLineup.type;
        this.buyModel.venueName = singleLineup.venueName;
        this.buyModel.name = singleLineup.name;
        this.isAlreadyInCart = response.isAlreadyInCart;
        this.selectedEventId = this.eventId;
        this.buyModel.eventListPricesName = response.Name;
  
        for (let i = 0; i < response.Prices.length; i++) {
          const Prices = response.Prices;
          if (i === 0) {
            this.buyModel.basePrice = Prices[i].BasePrice;
            this.eventTierId = Prices[i].TierID;
            this.buyModel.priceToPick = Prices[i];
          } else {
            if (Prices[i].BasePrice < this.buyModel.basePrice) {
              this.buyModel.basePrice = Prices[i].BasePrice;
              this.eventTierId = Prices[i].TierID;
              this.buyModel.priceToPick = Prices[i];
  
            }
          }
        }
        this.showingId = response.EventID;
        console.log(response);
        if (this.buyModel.priceToPick.TicketType === 'Streaming' && this.promoCode !== undefined && this.promoCode !== '') {
          this.isInvalidPromoCode = true;
          this.promoCode = '';
          this.cookiesService.setCookieValue('promoCode', this.promoCode);
        }
        this.isLoading = false;
      },
      (error: any) => {
        console.log(error);
        if(error === 500){
        this.errorMessage.errorMessage = 'Requested Item is currently not on sale.';
        this.errorMessage.isError = true;
        this.changeError.emit(this.errorMessage);
        this.isLoading = false;
        }
        else if(error === 403){
          this.errorMessage.errorMessage = 'Login to Creatics to purchase tickets.';
          this.errorMessage.isError = true;
          this.changeError.emit(this.errorMessage);
          this.isLoading = false;
        }
        else{
        this.errorMessage.errorMessage = 'Something went wrong.';
        this.errorMessage.isError = true;
        this.changeError.emit(this.errorMessage);
        this.isLoading = false;
        }
      });
    }
  }

  constructor(private cookiesService: CookiesService,
              private agileIntegrationService: AgileIntegrationService,
              public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private authService: AuthenticationService) {

              }

  ngOnInit(): void {
    this.fetchPromoCodeFromCookies();
    this.enableBuyTks(false);
    this.authService.checkUserAuthenticated().subscribe((res)=>{
      if(res.userId == 0){
        alert("Please login to Creatics to purchase tickets.")
        this.errorMessage.errorMessage = 'Login to Creatics to purchase tickets.';
        this.errorMessage.isError = true;
        this.changeError.emit(this.errorMessage);
        this.isLoading = false;
      }
    }, err=>{

    })
   
  }

  fetchPromoCodeFromCookies(): void {
    this.promoCode = this.cookiesService.getCookieValue('promoCode');
  }

  closeModal(): void {
    this.activeModal.close();
  }

  proceedToCart(): void {
    this.enableCart.emit();
  }

  addToCart(): void {
    this.isLoading = true;
    console.log("event id", this.eventId);
    console.log("showing id", this.showingId);
    this.agileIntegrationService.addToCart(this.eventId, this.showingId, this.eventTierId, this.promoCode).subscribe(response => {
      this.isLoading = false;
      console.log(response);
      this.proceedToCart();
    },
    error => {
      this.isLoading = false;
      console.log(error);
      this.proceedToCart();
    });
    
  }

}
